import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { UserData } from '../../providers/user-data'
import { Storage } from '@ionic/storage';
import { HomePage } from '../home/home';

/**
 * Generated class for the ChangePasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {
  changePasswordForm: FormGroup
  constructor(public neavController: NavController, private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private alertCtrl: AlertController, private userData: UserData, private events: Events, private storage: Storage) {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8)]],
      passwords: this.formBuilder.group({
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmNewPassword: ['', [Validators.required, Validators.minLength(8)]]
      }, { validator: this.validatePassword }),
    })
  }

  ionViewDidLoad() {
  }

  onSubmit(value) {
    this.userData.changePassword(value).subscribe(
      res => {
        if (res['success']) {
          this.presentToast('Password changed successfully')
          this.events.publish('menu:toggle', true);
          this.storage.set('changepassword', true);
          this.changePasswordForm.reset()
          this.neavController.setRoot(HomePage);
        }
      },
      err => {
        console.log(err)
        if (err['error']) {
          this.presentAlert('Error', err.error.message)
        }
      }
    )
  }

  validatePassword(formControl: AbstractControl): { [key: string]: boolean } {
    const password = formControl.get('newPassword');
    const confirmpassword = formControl.get('confirmNewPassword');
    if (!password || !confirmpassword) { return null; }
    return password.value === confirmpassword.value ? null : { nomatch: true };
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts